var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 19.1673C5.37484 19.1673 4.98248 19.0041 4.65609 18.6777C4.3297 18.3513 4.1665 17.959 4.1665 17.5007V2.50065C4.1665 2.04232 4.3297 1.64996 4.65609 1.32357C4.98248 0.997179 5.37484 0.833984 5.83317 0.833984H14.1665C14.6248 0.833984 15.0172 0.997179 15.3436 1.32357C15.67 1.64996 15.8332 2.04232 15.8332 2.50065V17.5007C15.8332 17.959 15.67 18.3513 15.3436 18.6777C15.0172 19.0041 14.6248 19.1673 14.1665 19.1673H5.83317ZM5.83317 16.6673V17.5007H14.1665V16.6673H5.83317ZM5.83317 15.0007H14.1665V5.00065H5.83317V15.0007ZM5.83317 3.33398H14.1665V2.50065H5.83317V3.33398Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.a35eb545ca77c2f1ba57af9bfc90a082.svg";
export { ForwardRef as ReactComponent };